<div class="panel__header">
  <div>
    <h2>{{ 'admin.audit.title' | adminTranslate }}</h2>
  </div>
  <div class="panel__actions">
    <div class="toolbar toolbar--compact">
      <ui-input [(ngModel)]="filters.query" size="sm" [placeholder]="'admin.audit.searchPlaceholder' | adminTranslate"></ui-input>
      <ui-select size="sm" [(ngModel)]="filters.success" (ngModelChange)="applyFilters()">
        <option value="">{{ 'admin.common.allStatuses' | adminTranslate }}</option>
        <option value="true">{{ 'admin.common.status.success' | adminTranslate }}</option>
        <option value="false">{{ 'admin.common.status.error' | adminTranslate }}</option>
      </ui-select>
    </div>
    <ui-button variant="secondary" size="sm" (click)="applyFilters()">{{ 'admin.common.filter' | adminTranslate }}</ui-button>
    <ui-button variant="secondary" size="sm" (click)="resetFilters()">{{ 'admin.common.clear' | adminTranslate }}</ui-button>
    <button
      type="button"
      class="btn-icon btn-icon-refresh"
      (click)="loadAuditEvents()"
      [disabled]="loadingAudit"
      [title]="'admin.common.refresh' | adminTranslate"
      [attr.aria-label]="'admin.common.refresh' | adminTranslate">
      <ui-icon name="refresh"></ui-icon>
    </button>
  </div>
</div>

@if (loadingAudit) {
  <p class="empty">{{ 'admin.audit.loading' | adminTranslate }}</p>
} @else if (auditEvents.length) {
  <p class="audit-count">{{ 'admin.audit.count' | adminTranslate:{ count: auditTotal } }}</p>

  <div class="audit-table-wrap">
    <table class="audit-table">
      <thead>
        <tr>
          <th>{{ 'admin.audit.event' | adminTranslate }}</th>
          <th>{{ 'admin.audit.context' | adminTranslate }}</th>
          <th>{{ 'admin.audit.status' | adminTranslate }}</th>
          <th>{{ 'admin.support.actions' | adminTranslate }}</th>
        </tr>
      </thead>
      <tbody>
        @for (event of auditEvents; track event.id) {
          <tr>
            <td>
              <div class="audit-event">
                <strong>{{ actionLabel(event.actionType) }}</strong>
                <p>{{ event.reason || ('admin.audit.noReason' | adminTranslate) }}</p>
                <span class="audit-subtle">{{ formatOccurredAt(event.occurredAt) }}</span>
              </div>
            </td>
            <td>
              <div class="audit-context">
                <span>{{ 'admin.audit.actorType' | adminTranslate:{ value: event.actorUsername || event.actorType || 'SYSTEM' } }}</span>
                @if (event.effectiveUserId) {
                  <span>{{ 'admin.audit.effectiveUser' | adminTranslate:{ value: event.effectiveUsername || event.effectiveUserId } }}</span>
                }
                @if (event.requestId) {
                  <span>{{ 'admin.audit.requestIdLabel' | adminTranslate:{ value: event.requestId } }}</span>
                }
                @if (event.requestPath) {
                  <span>{{ 'admin.audit.requestPathLabel' | adminTranslate:{ value: event.requestPath } }}</span>
                }
              </div>
            </td>
            <td>
              <div class="audit-status">
                <span class="status" [class.status--active]="event.success" [class.status--closed]="!event.success">
                  {{ statusLabel(event) }}
                </span>
                @if (event.supportSessionId) {
                  <span class="audit-tag audit-tag--support">{{ 'admin.audit.supportTag' | adminTranslate }}</span>
                } @else if (event.delegated) {
                  <span class="audit-tag audit-tag--delegated">{{ 'admin.audit.delegationTag' | adminTranslate }}</span>
                }
              </div>
            </td>
            <td>
              <div class="table-actions">
                <ui-button variant="secondary" size="sm" [routerLink]="['/audit', event.id]">{{ 'admin.common.detail' | adminTranslate }}</ui-button>
                @if (event.effectiveUserId) {
                  <ui-button variant="secondary" size="sm" [routerLink]="['/users', event.effectiveUserId]">{{ 'admin.common.account' | adminTranslate }}</ui-button>
                }
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
} @else {
  <p class="empty">{{ 'admin.audit.empty' | adminTranslate }}</p>
}
